import SettingsCard from "./SettingsCard";

export type SettingsCardType = {
  icon: JSX.Element;
  title: string; // ✅ fixed
  description: string; // ✅ fixed
  href?: string;
  haveAccess: boolean;
  isSoon?: boolean;
  shouldShow: boolean;
  needSubscription?: boolean;
  action?: () => void;
};


// ✅ Add this type to fix the error
type SettingsGridContainerProps = {
  title: string;
  cards: SettingsCardType[];
};

function SettingsGridContainer({ title, cards }: SettingsGridContainerProps) {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-4">
      <h2 className="col-span-2 py-1 text-[40px] capitalize md:col-span-3 xl:col-span-4">{title}</h2>
      {cards.map((card, i) => (
        <SettingsCard
          key={i}
          icon={card.icon}
          title={card.title}
          description={card.description}
          href={card.href}
          haveAccess={card.haveAccess}
          shouldShow={card.shouldShow}
          isSoon={card.isSoon}
          needSubscription={card.needSubscription}
          action={card.action}
        />
      ))}
    </div>
  );
}

export default SettingsGridContainer;
